import React from 'react';
import ReactDOM from 'react-dom';
import { getFileBufferByUrl} from 'Api/index';
import {store} from 'Store/store.index';
import Hammer from 'hammerjs';
import {
  // SAVE_TO_LOCAL,
  // SAVE_TO_DOWNLOAD,
  SAVE_TO_GOOGLE_DRIVE,
  SAVE_TO_ONE_DRIVE,
  SAVE_TO_BOX,
  SAVE_TO_DROPBOX,
  SAVE_TO_PRIVATE_DRIVE,
  SAVE_TO_PRIVATE_DRIVE_S3,
  SAVE_TO_PRIVATE_DRIVE_NFS,
} from '../ui/constants/savefile.constants';
import {
  ORGANIZE_TAB_FLATTEN,

  ORGANIZE_TAB_WATERMARK,
  ORGANIZE_TAB_WATERMARK_ADD,
  ORGANIZE_TAB_WATERMARK_UPDATE,
  ORGANIZE_TAB_WATERMARK_REMOVEALL,

  ORGANIZE_TAB_BACKGROUND,
  ORGANIZE_TAB_BACKGROUND_ADD,
  ORGANIZE_TAB_BACKGROUND_UPDATE,
  ORGANIZE_TAB_BACKGROUND_REMOVEALL,

  ORGANIZE_TAB_HEADER_FOOTER,
  ORGANIZE_TAB_HEADER_FOOTER_ADD,
  ORGANIZE_TAB_HEADER_FOOTER_UPDATE,
  ORGANIZE_TAB_HEADER_FOOTER_REMOVEALL,

  ORGANIZE_TAB_BATES_NUMBERING,
  ORGANIZE_TAB_BATES_NUMBERING_ADD,
  ORGANIZE_TAB_BATES_NUMBERING_REMOVEALL,

  ORGANIZE_TAB_PAGE_ROTATE,
  ORGANIZE_TAB_PAGE_ROTATE_LEFT,
  ORGANIZE_TAB_PAGE_ROTATE_RIGHT,
} from '../ui/constants/organize.constants';
import { FILE_TAB_GROUP_FILE_OPTIMIZER } from "../ui/constants/file.constants";
import {
  CONVERT_EXPORT_IMAGES,
  CONVERT_PDF_TO_OFFICE,
  CONVERT_PDF_TO_WORD,
  CONVERT_PDF_TO_XML_SPREADSHEET_2003,
  CONVERT_PDF_TO_WORD_2003,
  CONVERT_PDF_TO_EXCEL,
  CONVERT_PDF_TO_PPT,
  CONVERT_PDF_TO_IMAGE,
  CONVERT_PDF_TO_PNG,
  CONVERT_PDF_TO_JPEG,
  CONVERT_PDF_TO_JPEG2000,
  CONVERT_PDF_TO_TIFF,
  CONVERT_PDF_TO_BMP,
  CONVERT_PDF_TO_OTHER,
  CONVERT_TO_PDF_SETTINGS,
  CONVERT_PDF_TO_RTF,
  CONVERT_PDF_TO_TXT,
  CONVERT_PDF_TO_ACCESSIBLE_TXT,
  CONVERT_PDF_TO_HTML,
  CONVERT_PDF_TO_XML_STARDARD,
  CONVERT_PREFLIGHT,
  OCR_QUICK_RECOGNITION,
} from "../ui/constants/convert.constants";
import {
  PROTECT_CERTIFICATE_PROTECT,
  PROTECT_SECURITY_POLICIES,
} from '../ui/constants/protect.constants';
import {
  FORM_RECOGNITION_FORM,
  FORM_CREATE_TEXT_FIELD,
  FORM_CREATE_SIGN_FIELD,
  FORM_CREATE_RADIO_BTN_FIELD,
  FORM_CREATE_PUSH_BTN_FIELD,
  FORM_CREATE_CHECK_BOX_FIELD,
  FORM_CREATE_COMBO_BOX_FIELD,
  FORM_CREATE_LIST_BOX_FIELD,
  FORM_CREATE_IMAGE_FIELD,
  FORM_CREATE_DATE_FIELD,
  FORM_EDIT_XFA_FORM_BUTTON,
  FORM_RESET_FIELD,
  FORM_ADD_TOOLTIP
  } from 'Components/viewer/ui/constants/form.constants';
import { download} from 'Api/download.api';
import { isSameRect, isSameRects, isInRect} from 'Utils/math';
import { ROTATE_RIGHT, ROTATE_LEFT} from '../ui/constants/float_bar.constants';
import AnnotationStateHandler from './AnnotationStateHandler'
import { createSelectionStateHandler } from '../ui/ViewerComponents/index';
import { getHeaderAndOriginAnnot } from '@/utils/sdk_utils';
import {  FileData } from 'Api/index';
import intl from 'react-intl-universal';
import { getDigitalIDs as getLocalDigitalIDs } from 'Components/dialogs/AddDigitalID/utils';
import { blobToBase64, createDeferred } from 'Utils/utils';
import PromptDigitalIDPassword from 'Components/dialogs/PromptDigitalIDPassword';
import PromptPassword from 'Components/dialogs/PromptPassword';
import { APPLY_ALL_SIGNATURE, MANAGE_SIGNATURE } from '../ui/constants/fill_sign.constants';

/**
 * @typedef {Object} User_Permissions
 * @property {Number} print  Print PDF document with normal mode. (Bit 3 in permission value)
 * @property {Number} modify Modify PDF contents. (Bit 4 in permission value)\n
 *      If this value is set, user can modify contents of PDF document by operations other than those controlled by values User_Permissions::annotForm, \n
 *      User_Permissions::efillForm and User_Permissions::assemble.
 * @property {Number} extract: Extract PDF contents. (Bit 5 in permission value)\n
 *      If this value is set, user can copy or otherwise extract text and graphics from the document by operations other\n
 *      than that controlled by value User_Permissions::extractAccess.
 * @property {Number} annotForm Operate text annotations and fill in interactive form fields. (Bit 6 in permission value)\n
 *      If value User_Permissions::modify is also set, user can create or modify interactive form fields (including signature fields).
 * @property {Number} fillForm Fill PDF form. (Bit 9 in permission value)\n
 *      If this value is set, user can fill in interactive form fields (including signature fields), even if value User_Permissions::annotForm is not used.
 * @property {Number} extractAccess: Disabilities support. (Bit 10 in permission value)\n
 *      If this value is set, user can extract text and graphics in support of accessibility to users with disabilities or for other purposes.
 * @property {Number} assemble Assemble PDF document. (Bit 11 in permission value)\n
 *      If this value is set, it enables to assemble the document (Insert, rotate, or delete pages and create bookmarks or thumbnail images), \n
 *      regardless if value User_Permissions::modify is set or not.
 * @property {Number} printHigh Print PDF document with higher qualities. (Bit 12 in permission value)\n
 *      If this value is not set (and value User_Permissions::print is set), printing is limited to a low-level representation of the appearance, possibly of degraded quality.
 */


export const PERMISSION_KEYS={
  print:"print",
  docchange:"docchange",
  docassembly:"docassembly",
  doccopy:"doccopy",
  doccopyforaccessibility:"doccopyforaccessibility",
  pageextraction:"pageextraction",
  commenting:"commenting",
  fillingofformfield:"fillingofformfield",
  signing:"signing"
}

let $$ = function () {
  console.error('$$ is not support, please initialize...')
  return [];
};
// define in '../style/viewer.selection'
const markSelectClassName = 'fv__mark-selection-blank'; //fo__mark-selection-blank
const markSelectSelector = '.' + markSelectClassName;// + " .fo__mark-selection-blank";
const markColorBurnCls = '.color-burn';

//const markMultiSelectClassName = 'fo__mark-multi-selection-blank';
//const markMultiSelectSelector = '.' + markSelectClassName;

export default class FileController {
  constructor() {
    this.pdfui = null;
    this.pdfViewer = null;
    this.annotationStateHandler = null;
    this.prevStateHandler = null;
    this.addedAnnotsList = []

    this.$lastParent = null;
    this.removePageStatus = false;

    this.initialize = this.initialize.bind(this);

    this.doOpenFileByUrl = this.doOpenFileByUrl.bind(this);

    this.getPDFViewer        = this.getPDFViewer.bind(this);
    this.getPageImageData    = this.getPageImageData.bind(this);
    this.getPageThumb        = this.getPageThumb.bind(this);
    this.flattenPDF          = this.flattenPDF.bind(this);
    this.addWatermark        = this.addWatermark.bind(this);
    this.addBackground       = this.addBackground.bind(this);
    this.setTrustConfig      = this.setTrustConfig.bind(this);
    this.getAllAutoCompleteEntries      = this.getAllAutoCompleteEntries.bind(this);
    this.getCurrentDocBuffer = this.getCurrentDocBuffer.bind(this);
    this.saveFile            = this.saveFile.bind(this);
    this.saveToLocal         = this.saveToLocal.bind(this);
    this.getUserPermissions  = this.getUserPermissions.bind(this);
    this.checkPermission     = this.checkPermission.bind(this);

    this.getFileName              = this.getFileName.bind(this)
    this.renderPageByHeaderFooter = this.renderPageByHeaderFooter.bind(this);
    this.getDocMetaDataByFormat   = this.getDocMetaDataByFormat.bind(this);
    this.setDocAuthor             = this.setDocAuthor.bind(this);

    // search
    this.findTextInWholeDoc = this.findTextInWholeDoc.bind(this);
    this.gotoPage           = this.gotoPage.bind(this);
    this.formatTextMatch    = this.formatTextMatch.bind(this);
    this.formatFindNexts    = this.formatFindNexts.bind(this);
    this.removeSelectMark   = this.removeSelectMark.bind(this);
    this.appendSelectMark   = this.appendSelectMark.bind(this);
    this.updateSelectMark   = this.updateSelectMark.bind(this);
    this.markTextSelection  = this.markTextSelection.bind(this);
    this.clearMarkTexts      = this.clearMarkTexts.bind(this);
    this.transformRectArray = this.transformRectArray.bind(this);
    this.doAnnotSelectionState = this.doAnnotSelectionState.bind(this);
    this.onClickAnnotTooltip = this.onClickAnnotTooltip.bind(this);
    //label
    this.onListenSwitchToFn       = this.onListenSwitchToFn.bind(this);
    this.onListenSelectText       = this.onListenSelectText.bind(this);
    this._cleanListenerOfSwitchTo = this._cleanListenerOfSwitchTo.bind(this);
    this._switchToLastHandler     = this._switchToLastHandler.bind(this);
    this.switchToSelectText       = this.switchToSelectText.bind(this);
    this.cancelSwitchToSelectText = this.cancelSwitchToSelectText.bind(this);
    this.getSelectedText          = this.getSelectedText.bind(this);
    //getPageSizesByIndex
     this.getPageSizesByIndex     = this.getPageSizesByIndex.bind(this);

     this.fullFeature = 1;
  }

  async initialize(pdfui) {
    this.pdfui = pdfui;
    $$ = window.UIExtension.jQuery;
    this.annotationStateHandler = new AnnotationStateHandler(pdfui, this);
    this.pdfViewer = await this.getPDFViewer();
    pdfui.getStateHandlerManager().then(stateHandlerManager => {
        //stateHandlerManager.switchTo('SelectTextAnnotationController');
        let SelectionStateHandler = createSelectionStateHandler(UIExtension);
        stateHandlerManager.register(SelectionStateHandler);

    });

    // 添加删除监听，用于在下载保存文档时添加相应的flag
    const Events = UIExtension.PDFViewCtrl.Events;
    pdfui.addViewerEventListener(Events.openFileSuccess, () =>{
      this.removePageStatus = false;
    });
    pdfui.addViewerEventListener(Events.pageRemoved, () => {
      this.removePageStatus = true;
    });
    pdfui.addViewerEventListener(Events.removeEmbeddedPageThumbnail, () => {
      this.removePageStatus = true;
    });

  }
  closeCurrentPDFDoc() {
    return this.pdfViewer.close()
  }
  async getDocAllAnnotsID() {
    let annotsIDArr = []
    let allAnnotsArr = await this.getDocAllAnnots()

    allAnnotsArr && allAnnotsArr.forEach((annot) => {
      const { originAnnot, headerAnnot } = annot

      annotsIDArr.push(originAnnot.getName())
      annotsIDArr.push(headerAnnot.getName())
    })

    return annotsIDArr
  }
  //根据文档缩放方式来获取gotolink的属性
  async getActionDataByGoToLink(destIndex) {
    let actionData = {}
    actionData.pageIndex = destIndex;
    let docRenderScale = await this.getDocScale();
    let viewer = await this.pdfui.getPDFViewer();
    let pageRender = viewer.getPDFPageRender(actionData.pageIndex);
    let position = viewer.getDeviceCurrentPosition();
    let positionLeft = Number(position.left).toFixed(2);
    let positionTop = Number(position.top).toFixed(2);
    let [left, top] = await pageRender.reverseDevicePoint([Number(positionLeft), Number(positionTop)], pageRender.getScale(), pageRender.getRotation());
    actionData.left = left;
    actionData.top = top;
    switch (docRenderScale) {
      case "fitWidth":
        actionData.zoomMode = "ZoomFitHorz";
        break;
      case "fitHeight":
        actionData.zoomMode = "ZoomFitPage";
        break;
      case "fitVisible":
        actionData.zoomMode = "ZoomFitBHorz";
        break;
      default:
        actionData.zoomMode = "ZoomXYZ";
        actionData.zoomFactor = viewer.getPDFPageRender(actionData.pageIndex).getScale();
        break;
    }
    return actionData;
  }
  //获取当前文档缩放方式
  async getDocScale() {
    let viewer = await this.pdfui.getPDFViewer();
    let docRender = viewer.getPDFDocRender();
    let docRenderScale = docRender.getScale();
    return docRenderScale;
  }
  async getPageSizesByIndex(index) {
    const doc = await this.pdfui.getCurrentPDFDoc();
    const pageSize = await doc.getPageSizesByIndex(index);
    return pageSize[index] || {width:595, height:842, rotation: 0};
  }
  //获取文档当前页码
  getCurrentPageIndex(){
    return this.pdfui.pdfViewer.pdfViewerRender.pdfDocRender.getCurrentPageIndex();
  }
  //获取指定页面的annot
  async getAnnotsByPageIndex(pageIndex){
    let docIndex=pageIndex||pageIndex===0?pageIndex:this.getCurrentPageIndex();
    let PDFPage=await this.pdfui.pdfViewer.currentPDFDoc.getPageByIndex(docIndex);
    return await PDFPage.getAnnots();
  }
  //获取指定页面urllink
  async getUrlLinksObj(pageIndex){
    let docIndex=pageIndex||pageIndex===0?pageIndex:'';
    let annots=await this.getAnnotsByPageIndex(docIndex);
    let url=[];
    let index=0;
    for(let i in annots){
      if (annots[i].getType() !== 'link') continue;
      let linkType=annots[i].info.action&&annots[i].info.action.type;
      if(linkType==='TypeURI'){
        let currentUrl=annots[i].info.action.uri;
        index=index+1;
        let obj={
          key:index-1,
          Url:currentUrl,
          file:new FileData(currentUrl, 'html2pdf.url', 'Url'),
          Status:intl.formatMessage({ id: 'AppendWebLinks.connect' }),
          actived:false
        }
        url.push(obj);
      }
    }
    return url;
  }
  async getDocAllAnnots() {
    let allAnnotsArr = []
    const doc = await pdfui.getCurrentPDFDoc().catch((error)=> {
      throw error
    })

    if (!doc) {
      return
    }

    const annotsWrapperArr = await doc.getAnnots().catch((error) => {
      throw error
    })

    for(let i = 0; i < annotsWrapperArr.length; i++) {
      const annotsWrapper = annotsWrapperArr[i]

      if (!annotsWrapper.length) {
        continue
      }

      const annotArr = getHeaderAndOriginAnnot(annotsWrapper)

      if (!annotArr.length) {
        return
      }

      annotArr.forEach((annot) => {
        const {originAnnot, headerAnnot} = annot

        allAnnotsArr.push({ originAnnot, headerAnnot})
      })
    }

    return allAnnotsArr
  }
  async checkAnnotFormPermission() {
    const doc = await pdfui.getCurrentPDFDoc()
    const userPermission = new UIExtension.PDFViewCtrl.UserPermission(doc.getUserPermissions())

    const result = userPermission.checkAnnotForm()

    return result
  }
  async importXFDFToAnnots({doc, xfdfBlob, success}) {
      await doc.importAnnotsFromFDF(xfdfBlob).catch((error) => {
        throw error
      })
      success && success()
  }
  async importAnnotsFromFDF(fdfBlob) {
    const doc = await this.pdfui.getCurrentPDFDoc();

    await doc.importAnnotsFromFDF(fdfBlob)
  }
  async exportAnnotsToFDF() {
    const doc = await this.pdfui.getCurrentPDFDoc();
    const fdfBlob = await doc.exportAnnotsToFDF(0, null);

    return fdfBlob
  }
  async exportAnnotsToXFDF({doc, annot}) {
    const xfdfBlob = await doc.exportAnnotsToFDF(1, [annot]);

    return xfdfBlob
  }
  insertBlankPage = async (pageCount, pageIndex, callback) => {
    try {
      const currentPdfDoc = await this.pdfui.getCurrentPDFDoc();
      const currentPage = await currentPdfDoc.getPageByIndex(pageIndex >= pageCount ? pageIndex - 1 : pageIndex)
      const pageWidth = currentPage.getWidth()
      const pageHeight = currentPage.getHeight()

      for (let index = 0; index < pageCount; index++) {
        await currentPdfDoc.insertPage(pageIndex, pageWidth, pageHeight)

        if (index === pageCount - 1) {
          callback && callback()
          // this.getDocInfo(callback)
        }
      }
    } catch (error) {
      console.error("FileController -> removePage -> error", error)
    }
  }
  removePage = async (range) => {
    const pageIndexArr = []
    const pageInfoArr = range.split(',')

    pageInfoArr.forEach(element => {
      const trimElement = element.trim()

      if(trimElement.indexOf('-') > -1) {
        const startPage = parseInt(trimElement[0])
        const endPage = parseInt(trimElement[2])

        for (let index = startPage - 1; index < endPage; index++) {
          pageIndexArr.push(index)
        }
      } else {
        pageIndexArr.push(parseInt(trimElement) - 1)
      }
    });

    pageIndexArr.sort(function(a, b) {
      return b - a
    })

    try {
      const currentPdfDoc = await this.pdfui.getCurrentPDFDoc();

      pageIndexArr.forEach(pageIndex => {
        currentPdfDoc.removePage(pageIndex)
      });
    } catch (error) {
      console.error("FileController -> removePage -> error", error)
    }
  }

  getPDFViewer() {
    return this.pdfui.getPDFViewer();
  }

  combineFormsToCSV({files, fileName}, callback, errCallback){
    this.pdfViewer.getWebPDFJR().then(engine=>{
      let CombindForms = UIExtension.PDFViewCtrl.CombindForms;

      let bindForms = new CombindForms(engine);
      let buffers = [];
      let name = fileName;//'data source.csv';// files[0].name + '.csv';
      let filesArray = files.map((file)=>{
        return {file:file, name:file.name}
      })
      bindForms.combineFormsToCSV(filesArray,({ arrayBuffer,blob}) => {
          if(blob){
              buffers=blob;
          }else{
              buffers.push(arrayBuffer);
          }
      }).then((result)=>{
        //'application/csv'
        download(buffers, name, 'application/csv');
        callback && callback(result)
      }).catch((err)=>{
        errCallback && errCallback(err);
      });
    })
  }

  async renderPageByHeaderFooter(pageIndex, clientWidth, clientHeight){
    if(!this.pdfui){
      return {};
    }
    let doc = await this.pdfui.getCurrentPDFDoc()
    if(!doc){
      return {};
    }
    let page     = await doc.getPageByIndex(pageIndex);
    let pageSize = await this.getPageSizesByIndex(pageIndex);
    let scale    = Math.round(clientWidth*100*(72/96)/pageSize.width)/100;
    let width    = clientWidth;                                     // pageSize.width;

    let height         = clientHeight;                                            // Math.round(width*clientHeight/clientWidth);
    let area           = {x:0, y:0, width, height }
    let pageImageData0 = await page.render(scale, 0, area);
        area           = {x:0, y: Math.round(pageSize.height*scale*(96/72))-height, width, height };
    let pageImageData1 = await page.render(scale, 0, area);
    return {
      scale,
      width,
      height,
      image0:pageImageData0,
      image1:pageImageData1
    }
  }

  getPageImageData(pageIndex, clientWidth, clientHeight){
    if(!pageIndex)pageIndex=0;
    if(!clientWidth) clientWidth = 704;
    if(!clientHeight) clientHeight = 75;
    let selector = `.fv__pdf-page-container[data-index="${pageIndex}"] .fv__tiles-canvas.fv__tiles-canvas-0-0`
    let cPage0   = document.querySelector(selector);
    let ctxPage0 = cPage0.getContext("2d");
    // 704 * 80; => cPage0 => width => width/704 = height/80

    let width  = cPage0.width;
    let height = Math.round(width*clientHeight/clientWidth);
    let image  = ctxPage0.getImageData(0,0,width,height);
    let image1 = ctxPage0.getImageData(0,cPage0.height-height,width,height);
    return {
      width,
      height,
      image,
      image1,
    }

  }

  /**
   *
   * @param {Number} pageIndex
   * @returns {{buffer: Uint8Array , width: Number, height: Number}}
   */
  async getPageThumb(pageIndex, ratio){
    let doc = await this.pdfui.getCurrentPDFDoc();
    let page = await doc.getPageByIndex(pageIndex);
    //  {buffer: Uint8Array , width: int, height: int}
    let obj = page.getThumb(0, ratio)
    return obj;
  }
  async getMediaBoxBitmap(pageIndex, width, height){
    let doc = await this.pdfui.getCurrentPDFDoc();
    let page = await doc.getPageByIndex(pageIndex);
    let obj = page.getMediaBoxBitmap(width, height)
    return obj;
  }
  async flattenPDF(setting){
    let doc = await this.pdfui.getCurrentPDFDoc()
    if(!doc){
      return;
    }
    const {Flatten_Option } = window.UIExtension.PDFViewCtrl.PDF.constant;
    if(setting.mode === 'all'){
      doc.flatten(Flatten_Option.all).then((/* results */)=>{


      });
      return;
    }
    const {pageRange} = setting;
    let tasks = [];
    pageRange.forEach((index)=>{
      tasks.push(doc.getPageByIndex(index));
    })
    Promise.all(tasks).then((pages)=>{
      tasks = [];
      pages.forEach((page)=>{
        tasks.push(page.flatten(Flatten_Option.all));
      })
      Promise.all(tasks).then((/* results */)=>{


      })
    })
  }

  async resetForm(){
    let doc = await this.pdfui.getCurrentPDFDoc()
    if (!doc) {
      return;
    }

    let form = doc.getPDFForm();
    if(!form){
      return;
    }
    form.resetForm()
  }

  async addTooltipForFormFiled(){
    let doc = await this.pdfui.getCurrentPDFDoc()
    if (!doc) {
      return;
    }

    this.getPDFViewer().then((viewer)=>{
      viewer.addTooltipsForAllFormFields();
    });
  }

  async getPageFormat(type, previewWidth = 324, previewHeight = 392, fileName='', newDocId='', localFormat = undefined){
    let doc = await this.pdfui.getCurrentPDFDoc()
    if (!doc) {
      return;
    }
    return doc.getPageFormat(type, previewWidth, previewHeight, fileName, newDocId, localFormat)
  }

  async addPageFormat(type, data, isUpdate = false){
    let stateHandlerManager = await window.pdfui.getStateHandlerManager();
    stateHandlerManager;;
    if(stateHandlerManager){
      stateHandlerManager.switchTo();
    }

    let doc = await this.pdfui.getCurrentPDFDoc()
    if (!doc) {
      return;
    }
    return doc.addPageFormat(type, data, isUpdate)
  }

  async getPageFormatThumb(type, pageIndex, data, isUpdate = false,  bitmapWidth = 324, bitmapHeight = 392, rotate = 0){
    let doc = await this.pdfui.getCurrentPDFDoc()
    if (!doc) {
      return;
    }
    return doc.getPageFormatThumb(type, pageIndex, data, isUpdate,  bitmapWidth, bitmapHeight, rotate)
  }

  async removeAllPageFormat(type){
    let doc = await this.pdfui.getCurrentPDFDoc()
    if (!doc) {
      return;
    }

    return doc.removeAllPageFormat(type)
  }

  async addWatermark({setting}){
    let doc = await this.pdfui.getCurrentPDFDoc()
    if (!doc) {
      return;
    }
    const {
      Position,
      Watermark_Flag,
      Standard_Font
    } = window.UIExtension.PDFViewCtrl.PDF.constant;
    // Standard_Font.courier helvetica
    const {
      text,
      textFont,
      fontSize,
      fontColor,
      opacity,
      rotate
    } = setting;
    let color = parseInt(fontColor.replace('#', '0x'), 16)
    let config = {
      type: "text",
      text,
      watermarkSettings: {
        position: Position.center,
        offsetX : 0,
        offsetY : 0,
        scaleX  : 1,
        scaleY  : 1,
        rotation: rotate,
        opacity : opacity,
        flags   : Watermark_Flag.asContent | Watermark_Flag.onTop
      },
      // Watermark_Flag.asContent
      watermarkTextProperties: {
        font     : Standard_Font[textFont],
        fontSize : parseInt(fontSize),
        color    : color,
        fontStyle: "normal",
        lineSpace: 1,
        alignment: "center"                  //"center"
      }
    };
    let docPageCount = doc.getPageCount();
    let tasks = [];
    for (let index = 0; index < docPageCount; index++) {
      tasks.push(doc.getPageByIndex(index));
    }
    Promise.all(tasks).then((pages)=>{
      tasks = [];
      pages.forEach((page)=>{
        tasks.push(page.addWatermark(config));
      })
      Promise.all(tasks).then((/* results */)=>{

      })
    })
  }

  async addBackground({setting}) {
    console.log('fileController', setting)
  }

  setDocAuthor(author){
    if(!this.pdfui)return;
    this.getPDFViewer().then((viewer)=>{
      viewer.setUserName(author);
    });
  }

  setTrustConfig({isEnableJS, isEnableSafeMode}){
    if(!this.pdfui)return;
    this.getPDFViewer().then((viewer)=>{
      viewer.setEnableJS(isEnableJS);
      viewer.setSafeReadingMode && viewer.setSafeReadingMode(isEnableSafeMode);
    });
  }
  async getAllAutoCompleteEntries(){
    let viewer     = await this.getPDFViewer();
    let doc        = viewer.getCurrentPDFDoc();
    if(doc){
      return viewer.getSavedAutoCompleteEntries();
    }
  }

  async clearAllAutoCompleteEntries(){
    let viewer     = await this.getPDFViewer();
    let doc        = viewer.getCurrentPDFDoc();
    if(doc){
       viewer.clearAllAutoCompleteEntries();
    }
  }


  async getUserPermissions(){
    let viewer     = await this.getPDFViewer();
    let doc        = viewer.getCurrentPDFDoc();
    if(!doc){
      return 0;
    }
    let permission = doc.getPermissions();// doc.getUserPermissions();
    return permission;
  }
  /**
   *
   *
   * @param {Number} permission
   * @param {User_Permissions} CONSTANTS_PERMISSION
   * @param {String} attr
   * @returns {Boolean} Allowed=>true, NotAllowed=>false
   * @memberof FileController
   */
  getDocSecurityInfo (permission, CONSTANTS_PERMISSION, attr) {
    switch (attr) {
      case "print":
        return ((permission & CONSTANTS_PERMISSION.print) || (permission & CONSTANTS_PERMISSION.printHigh)) ? true : false;
      case "docchange":
        return (permission & CONSTANTS_PERMISSION.modify) ? true : false;
      case "docassembly":
        return ((permission & CONSTANTS_PERMISSION.modify) || (permission & CONSTANTS_PERMISSION.assemble)) ? true : false;
      case "doccopy":
        return (permission & CONSTANTS_PERMISSION.extract) ? true : false;
      case "doccopyforaccessibility":
        return ((permission & CONSTANTS_PERMISSION.extract) || (permission & CONSTANTS_PERMISSION.extractAccess)) ? true : false;
      case "pageextraction":
        return (((permission & 0xFFFFFFFC)>>>0) === 0xFFFFFFFC) ? true : false;
      case "commenting":
        return (permission & CONSTANTS_PERMISSION.annotForm) ? true : false;
      case "fillingofformfield":
        return ((permission & CONSTANTS_PERMISSION.annotForm) ||
          (permission & CONSTANTS_PERMISSION.modify) ||
          (permission & CONSTANTS_PERMISSION.fillForm)) ? true : false;
      case "signing":
        return ((permission & CONSTANTS_PERMISSION.annotForm) ||
          (permission & CONSTANTS_PERMISSION.modify) ||
          (permission & CONSTANTS_PERMISSION.fillForm)) ? true : false;
      default:
        return false;
    }
  };

  checkPermission(permission, CONSTANTS_PERMISSION, actionName){
    //ORGANIZE_TAB_FLATTEN, ORGANIZE_TAB_WATERMARK, ORGANIZE_TAB_HEADER_FOOTER
    switch (actionName) {
      case CONVERT_EXPORT_IMAGES:
        // return (((permission & 0xFFFFFFFC)>>>0) === 0xFFFFFFFC);
      case CONVERT_TO_PDF_SETTINGS:
      case CONVERT_PDF_TO_OFFICE:
      case CONVERT_PDF_TO_WORD:
      case CONVERT_PDF_TO_XML_SPREADSHEET_2003:
      case CONVERT_PDF_TO_WORD_2003:
      case CONVERT_PDF_TO_EXCEL:
      case CONVERT_PDF_TO_PPT:
      case CONVERT_PDF_TO_IMAGE:
      case CONVERT_PDF_TO_PNG:
      case CONVERT_PDF_TO_JPEG:
      case CONVERT_PDF_TO_JPEG2000:
      case CONVERT_PDF_TO_TIFF:
      case CONVERT_PDF_TO_BMP:
      case CONVERT_PDF_TO_OTHER:
      case CONVERT_PDF_TO_XML_STARDARD:
      case CONVERT_PDF_TO_RTF:
      case CONVERT_PDF_TO_TXT:
      case CONVERT_PDF_TO_ACCESSIBLE_TXT:
      case CONVERT_PDF_TO_HTML:
      case CONVERT_PREFLIGHT:
        return permission & CONSTANTS_PERMISSION.extract;
      case FILE_TAB_GROUP_FILE_OPTIMIZER:
      case ORGANIZE_TAB_FLATTEN:
      // case FORM_RESET_FIELD:
      case FORM_ADD_TOOLTIP:
      case FORM_RECOGNITION_FORM:
      case FORM_CREATE_TEXT_FIELD:
      case FORM_CREATE_SIGN_FIELD:
      case FORM_CREATE_RADIO_BTN_FIELD:
      case FORM_CREATE_PUSH_BTN_FIELD:
      case FORM_CREATE_CHECK_BOX_FIELD:
      case FORM_CREATE_COMBO_BOX_FIELD:
      case FORM_CREATE_LIST_BOX_FIELD:
      case FORM_CREATE_IMAGE_FIELD:
      case FORM_CREATE_DATE_FIELD:
      case FORM_EDIT_XFA_FORM_BUTTON:
        return (permission & CONSTANTS_PERMISSION.modify) && (permission & CONSTANTS_PERMISSION.annotForm) && (permission & CONSTANTS_PERMISSION.fillForm);
      case FORM_RESET_FIELD:
        return (permission & CONSTANTS_PERMISSION.fillForm);
      case ORGANIZE_TAB_WATERMARK:
      case ORGANIZE_TAB_WATERMARK_ADD:
      case ORGANIZE_TAB_WATERMARK_UPDATE:
      case ORGANIZE_TAB_WATERMARK_REMOVEALL:
      case ORGANIZE_TAB_BACKGROUND:
      case ORGANIZE_TAB_BACKGROUND_ADD:
      case ORGANIZE_TAB_BACKGROUND_UPDATE:
      case ORGANIZE_TAB_BACKGROUND_REMOVEALL:
      case ORGANIZE_TAB_HEADER_FOOTER:
      case ORGANIZE_TAB_HEADER_FOOTER_ADD:
      case ORGANIZE_TAB_HEADER_FOOTER_UPDATE:
      case ORGANIZE_TAB_HEADER_FOOTER_REMOVEALL:
      case ORGANIZE_TAB_BATES_NUMBERING:
      case ORGANIZE_TAB_BATES_NUMBERING_ADD:
      case ORGANIZE_TAB_BATES_NUMBERING_REMOVEALL:
        return permission & CONSTANTS_PERMISSION.modify;
      case ORGANIZE_TAB_PAGE_ROTATE:
      case ORGANIZE_TAB_PAGE_ROTATE_LEFT:
      case ORGANIZE_TAB_PAGE_ROTATE_RIGHT:
      case ROTATE_LEFT:
      case ROTATE_RIGHT:
        return permission & CONSTANTS_PERMISSION.assemble;
      case PROTECT_CERTIFICATE_PROTECT:
      case PROTECT_SECURITY_POLICIES:
        return permission;
      case OCR_QUICK_RECOGNITION:
      case MANAGE_SIGNATURE:
        case APPLY_ALL_SIGNATURE:
        return permission & CONSTANTS_PERMISSION.modify
      default:
        break;
    }
  }

    getCurrentDocBuffer() {
        const state = localStorage.getItem('PREFERENCES-DOCUMENTS');
        let saveFlagLinearized = false;
        if (state) {
            const saveForFastWeb = JSON.parse(state).saveForFastWeb;
            saveFlagLinearized = !!saveForFastWeb;
        }
        return this.getPDFViewer().then((pdfViewer) => {
            pdfViewer.activeElement(null);
            const buffers = [];
            const cfgOption = {
                CL_IntList: 'e_SaveFlagLinearized'
            };
            return Promise.resolve((pdfViewer._saveBefore || function() {})()).then(() => {
                if (saveFlagLinearized) {
                    return pdfViewer.currentPDFDoc.optimizer(cfgOption).then(({
                        buffer,
                        fileName
                    }) => {
                        return [
                            buffer,
                            fileName
                        ];
                    });
                }
                let doc  = pdfViewer.currentPDFDoc;
                const stat = this.removePageStatus;
                let flag = doc.hasSignature() ? 1 : 0;
                if(stat) {
                    flag = flag | 16; //如果存在删除，须加上此flag
                }
                // 如果处于编辑状态，需要先退出，否则拿不到最新的文档数据
                const stateHandleManager = pdfViewer.getStateHandlerManager();
                const currentStateName = stateHandleManager.getCurrentStates().getStateName();
                if (['page-editor', 'touch-up-editor'].includes(currentStateName)) {
                  stateHandleManager.switchTo('hand');
                }
                return pdfViewer.currentPDFDoc.getStream(({ arrayBuffer }) => {
                    buffers.push(arrayBuffer);
                }, flag)
                .then((/* _ */) => {
                    return [buffers, pdfViewer.currentPDFDoc.getFileName()];
                });
            });
        });
    }

  doDownloadUrl(url, fileName, env) {
    downloadUrl(url, fileName , env);
  }
  doSaveTo(url, fileName, target, env){
    let driveName;
    switch (target) {
      case 'Local Computer':
        this.doDownloadUrl(url, fileName, env);
        break;
      case 'OneDrive':
        driveName = ONE_DRIVE;
        break;
      case 'Box':
        driveName = BOX;
        break;
      case 'Dropbox':
        driveName = DROP_BOX;
        break;
      case 'Google Drive':
        driveName = GOOGLE_DRIVE;
        break  ;
      default:
        console.error("TCL: doSaveTo -> url, fileName, target", url, fileName, target)
        break;
    }
    if(!driveName){
      return;
    }
    store.taskStore.setTaskMessage({ title: 'UploadingFile', info: 'UploadingFile.info', type: 'in-doing', failed: false, progress: 5 });
    try {
      getFileBufferByUrl(url, async (blob) => {
        store.taskStore.setTaskMessage({ title: 'UploadingFile', info: 'UploadingFile.info', type: 'in-doing', failed: false, progress: 5 }, 1500);
        let file = blob;
        // 应用密文文件名加前后缀
        let doc = await this.pdfui.getCurrentPDFDoc();
        if (doc.redacted) {
            fileName = this._formatFileName(fileName);
        }
        file.name = fileName;
        this.saveFileToDrive({
          driveName,
          file,
          success: ({type}) => {
            if (type === 'update') {
              store.taskStore.setTaskMessage({ title: '', info: 'UpdatingFile.success', type: 'complete', failed: false }, 6000);
            } else if (type === 'create') {
              store.taskStore.setTaskMessage({ title: '', info: 'UploadingFile.success', type: 'complete', failed: false }, 6000);
            }
          },
          fail: ({type}) => {
            if (type === 'update') {
              store.taskStore.setTaskMessage({ title: '', info: 'UpdatingFile.fail', type: 'error'}, 6000);
            } else if (type === 'create') {
              store.taskStore.setTaskMessage({ title: '', info: 'UploadingFile.fail', type: 'error'}, 6000);
            }
            this.doDownloadUrl(url, fileName);
          },
        });
      });

    } catch (error) {
      console.error("TCL: doSaveTo -> error", error)

    }

  }

  async doOpenFileByUrl(url, fileName, error, useBuffer = true, success){
    if (!url) {
      throw new Error('url is empty')
    }

    if (!this.pdfui) {
      try {
        const startDate = new Date()

        await new Promise((resolve, reject) => {
          const handle = setInterval(() => {
            const endDate = new Date()
  
            if (endDate - startDate >= 60000) {
              reject()
              clearInterval(handle)
            } else if (this.pdfui) {
              resolve()
              clearInterval(handle)
            }

          }, 1000)
        })
        
      } catch {
        store.collaborationStore.setFwBeginShare(false)
        throw new Error('init error')
      }
    }

    if(!useBuffer){
      try {
        let result = await store.viewer.doOpenFile(url, null, fileName, true);
        success && success()
        return result;
      } catch (err) {
        this.pdfui.alert('phantom_online:toolbar.error.fileOpen.err');
        error && error(err);
        throw err;
      }
      return;
    }

    let fileData
    try {
      store.appStore.showLoadingWithMsg({show:true,msg:"Loading.file"})
      fileData = await getFileBufferByUrl(url)
      store.appStore.showLoading(false);
    } catch (err) {
      store.appStore.showLoading(false)
      this.pdfui.alert('phantom_online:toolbar.error.fileOpen.failed');
      error && error(err);
      throw err;
    }

    try {
      let result = await store.viewer.doOpenFile(fileData, null, fileName)
      //let result = await this.pdfui.openPDFByFile(fileData,{fileName});
      // store.appStore.showLoading(false)
      success && success(fileData)
      return result;
    } catch (err) {
      // store.appStore.showLoading(false)

      this.pdfui.alert('phantom_online:toolbar.error.fileOpen.err');
      error && error(err);
      throw err;
    }
  }

  commonFileErrorHandler = (err) => {
    if(err.error == 101)
      this.pdfui.alert('phantom_online:toolbar.error.fileOpen.errWithDownload');
    else if(err.error === 2)
      this.pdfui.alert('phantom_online:toolbar.error.fileOpen.errWithFormat');
    else if(err.error == 11)
      this.pdfui.alert('phantom_online:toolbar.error.fileOpen.errWithHandler');
    else
      this.pdfui.alert('phantom_online:toolbar.error.fileOpen.err');
  }

  async doOpenFileOfServiceModeOfClient(fileUrl, fileName, filePath, error, success) {
    store.appStore.updateProgressingInfo(true)

    if (filePath) {
      fileUrl = `${fileUrl.endsWith('/') ? (fileUrl + '/'): fileUrl}?file_path=${filePath}`;
    }

    getFileBufferByUrl(fileUrl, async (blob) => {
      let fileData = blob;

      try {
        let result = await store.viewer.doOpenFile(fileData, null, fileName)
        success && success(fileData)
        return result;
      } catch (err) {
        if (err) { // PDFUI 内部弹出
          if(blob.size == 0)
            err.error = 101;
          this.commonFileErrorHandler(err);
        }
        error && error(err);
        throw err;
      } finally {
        store.appStore.updateProgressingInfo(false)
      }
    },(err)=>{
      store.appStore.updateProgressingInfo(false)
      this.pdfui.alert('phantom_online:toolbar.error.fileOpen.errWithDownload');
      error && error(err);
    });
  }

  async doAutoOpenPaperCheckResult(paperCheckEngine, paperCheckId, paperCheckTitle, error, success) {
    store.appStore.showLoadingWithMsg({show:true,msg:"Loading.file"})
    store.paperCheckStore.checkResultPdfReport(paperCheckEngine, paperCheckId, paperCheckTitle, async  file => {
      store.appStore.showLoading(false);
      try {
        let result;
        if (file) {
          store.appStore.showLoading(true);
          result = await store.viewer.doOpenFile(file, null, file.name);
          success && success(file);
        }
        return result;
      } catch (err) {
        this.pdfui.alert('phantom_online:toolbar.error.fileOpen.err');
        error && error(err);
      } finally {
        store.appStore.showLoading(false);
      }
    }, err => {
      store.appStore.showLoading(false);
      this.pdfui.alert('phantom_online:toolbar.error.fileOpen.err');
      error && error(err);
    })
  }

  retryLocalCertificate = async (pdfDoc, options = {}, eventData, needRenderDoc = true) => {
    const showNoRights = () => {
      store.appStore.onShowWarningMessage(undefined, {
        message: 'PromptDigitalIDPassword.ErrorOpenNoRight',
        iconType: 'alert',
      }, true);
      return Promise.resolve();
    }

    const digitalIDs = await getLocalDigitalIDs();
    if (!digitalIDs.length) {
      return showNoRights();
    }

    const serials = await pdfDoc.getCertificateSerials();
    if (!serials.length) {
      return showNoRights();
    }

    let queue = Promise.resolve();
    digitalIDs.forEach((curr) => {
      if (serials.includes(curr.serial)) {
        queue = queue.then((result) => {
          if (result) {
            return Promise.resolve(result);
          } else {
            return this.promptDigitalIDPassword(curr);
          }
        });
      }
    });
    queue = queue.then((result) => {
      if (result) {
        const { digitalID, password } = result;
        options.certificateInfo = {
          pfxFile: digitalID.pfxFile,
          password: password,
        };
        if (needRenderDoc) {
          return this.pdfui.pdfViewer.reopenPDFDoc(pdfDoc, options, eventData);
        } else {
          return pdfDoc.parse(options);
        }
      } else {
        return showNoRights();
      }
    });

    return queue;
  };

  promptDigitalIDPassword = (digitalID) => {
    const deferred = createDeferred();

    const div = document.createElement('div');
    document.body.appendChild(div);
    const ref = React.createRef();
    const onClose = (correctPwd) => {
      ref.current.componentWillUnmount && ref.current.componentWillUnmount();
      document.body.removeChild(div);
      deferred.resolve(correctPwd ? {
        digitalID,
        password: correctPwd,
      } : null);
    };
    ReactDOM.render((
      <PromptDigitalIDPassword
        ref={ref}
        digitalID={digitalID}
        onClose={onClose}
      />
    ), div);

    return deferred.promise;
  };

  retryPassword = async (pdfDoc, options = {}) => {
    const password = await this.promptPassword(options);
    if (password === undefined) {
      return this.pdfui.alert(intl.get('PromptPassword.ErrorPermission'));
    }
    try {
      return await pdfDoc.parse({ password });
    } catch (e) {
      store.collaborationStore.setFwBeginShare(false)
      if (e.code === 3) {
        await this.pdfui.alert(intl.get('PromptPassword.ErrorInvalid'));
        return this.retryPassword(pdfDoc, options);
      }
      throw e;
    }
  };

  promptPassword = (options = {}) => {
    const deferred = createDeferred();

    const div = document.createElement('div');
    document.body.appendChild(div);
    const ref = React.createRef();
    const closeHandler = () => {
      ref.current.componentWillUnmount && ref.current.componentWillUnmount();
      document.body.removeChild(div);
    };
    const onOk = (pwd) => {
      deferred.resolve(pwd);
      closeHandler();
    };
    const onCancel = () => {
      deferred.resolve();
      closeHandler();
    };
    ReactDOM.render((
      <PromptPassword
        ref={ref}
        options={options}
        onOk={onOk}
        onCancel={onCancel}
      />
    ), div);

    return deferred.promise;
  };

  parsePDFByFile = async (file) => {
    const webPDFJR = await this.pdfui.getWebPDFJR();
    const pdfDoc = await webPDFJR.getPDFDocByFile(file);
    try {
      return await pdfDoc.parse({ password: '' });
    } catch (e) {
      if (e.code === 3) {
        return this.retryPassword(pdfDoc, { fileName: file.name });
      }
      if (e.code === 5) {
        return this.retryLocalCertificate(pdfDoc, {}, {}, false);
      }
      if (e.code === 2) {
        return this.pdfui.alert('alert.formatError');
      }
      if (e.code === 11) {
        return this.pdfui.alert('alert.securityError');
      }
      throw e;
    }
  }

  async doOpenBlank(){
    return this.pdfui.pdfViewer.createNewDoc()
  }

  openFilePrivateDrive(/* btnName */) {
    // store.privateDriveStore.setDriveName(driveName);
    store.privateDriveStore.setOperateType('open');
    store.privateDriveStore.setShowDrivesPanel(true);
  }

  openFileFromDrives(btnName) {
    let driveName = '';

    switch (btnName) {
      case 'open-file-from-google-drive':
        driveName = 'Google Drive';
        break;
      case 'open-file-from-one-drive':
        driveName = 'OneDrive';
        break;
      case 'open-file-from-box':
        driveName = 'Box';
        break;
      case 'open-fie-from-dropbox':
        driveName = 'DropBox';
        break;
      default:
        break;
    }

    return driveName
  }

  saveFile(btnName) {
    let saveToDriveName = '';

    switch (btnName) {
      // case SAVE_TO_DOWNLOAD:
      // case SAVE_TO_LOCAL:
      //   saveToDriveName = null;
      //   break;
      case SAVE_TO_GOOGLE_DRIVE:
        saveToDriveName = 'Google Drive';
        break;
      case SAVE_TO_ONE_DRIVE:
        saveToDriveName = 'OneDrive';
        break;
      case SAVE_TO_BOX:
        saveToDriveName = 'Box';
        break;
      case SAVE_TO_DROPBOX:
        saveToDriveName = 'DropBox';
        break;
      default:
        break;
    }
    return saveToDriveName
  }
  async saveToPrivateDrive(btnName, /* file, success, fail */) {
    let driveName = '';

    switch (btnName) {
      case SAVE_TO_PRIVATE_DRIVE:
        driveName = 'SMB';
        break;
      case SAVE_TO_PRIVATE_DRIVE_S3:
        driveName = 'S3'
        break;
      case SAVE_TO_PRIVATE_DRIVE_NFS:
        driveName = 'NFS'
        break;
      default:
        break;
    }

    store.privateDriveStore.setDriveName(driveName);

    store.privateDriveStore.setOperateType('save');
    store.privateDriveStore.setShowDrivesPanel(true)
  }
  async getFileName() {
    let doc = await this.pdfui.getCurrentPDFDoc();
    if(!doc){
      return "";
    }
    let {openFileInfo, isOpenedFromDrive} = store.driveStore
    let {openedFileInfo, isOpenedFromPrivateDrive} = store.privateDriveStore
    // let { fileName } = doc.parameters;
    let fileName = doc && doc.getFileName();


    if (isOpenedFromDrive) {
      return fileName || (openFileInfo && openFileInfo.fileName)
    } else if (isOpenedFromPrivateDrive) {
      return openedFileInfo && openedFileInfo.item && openedFileInfo.item.name;
    } else {
      return fileName
    }
  }

  async getFileSize(){
    let doc = await this.pdfui.getCurrentPDFDoc();
    if(doc && doc.info && doc.info.fileSize){
      return doc.info.fileSize;
    }
    return 0;
  }
  async getPageSizes(){
    let doc = await this.pdfui.getCurrentPDFDoc();
    if(doc.info.pageSizes) {
      return doc.info.pageSizes;
    }
    return [{width:595,height:842,rotation: 0}];
  }
  async getDocInfo(callback, ignores = ''){
    if(!this.pdfui){
      return {};
    }
    let doc = await this.pdfui.getCurrentPDFDoc()
    if(!doc){
      return {};
    }

    let { pdfVersion = '', isSecured = false } = store.docStore.docInfo;
    let docPageCount = doc.getPageCount();
    let docRender = await this.pdfui.getPDFDocRender();
    let currentPageIndex = docRender.getCurrentPageIndex();
    let pageSizes = [{width:595,height:842,rotation: 0}]
    const fileName = await this.getFileName()

    if (ignores.indexOf('pdfVersion') < 0 && doc.getFileVersion) {
      pdfVersion = await doc.getFileVersion();
    }

    if(doc.info.pageSizes){
      pageSizes =  doc.info.pageSizes;
    }

    if (ignores.indexOf('isSecured') < 0) {
      const securityEncryptType = window.UIExtension.PDFViewCtrl.shared.securityEncryptType;
      const securityType = await doc.getSecurityType();
      if (securityType === securityEncryptType.Password) {
        const passwordType = await doc.getPasswordType();
        isSecured = passwordType === 2 || passwordType === 3;
      } else if (securityType === securityEncryptType.Certificate) {
        isSecured = true;
      }
    }

    let info = {
      docPageCount,
      currentPageIndex,
      pageSizes,
      pdfVersion,
      fileName,
      isSecured,
      size: doc.info.fileSize,
      docId: doc.info.id
    }

    callback && callback(info);
    return info;
  }
  async getDocMetaData(callback) {
    if(!this.pdfui){
      return {};
    }
    let doc = await this.pdfui.getCurrentPDFDoc()
    if(!doc){
      return {};
    }

    const {metadata} = doc

    callback && callback(metadata)

    return metadata
  }
  prefixInteger(num, length){
    return (Array(length).join(0) + num).slice(-length);
  }
  formatDatetime(datetime){
    if(!datetime) return datetime;
    try{
        let d = new Date(datetime);
        if(d == "Invalid Date"){
            //D:20100917062505+10'00'
            if(datetime.substr(0,2) == "D:"){
                d = new Date();
                d.setUTCFullYear(datetime.substr(2,4))
                d.setUTCMonth(datetime.substr(6,2) - 1)
                d.setUTCDate(datetime.substr(8,2))
                d.setUTCHours(datetime.substr(10,2))
                d.setUTCMinutes(datetime.substr(12,2))
                d.setUTCSeconds(datetime.substr(14,2))
                let timezoneChar = datetime.substr(16,1);
                if(timezoneChar == '+' || timezoneChar == '-'){
                    let timezoneH = datetime.substr(17,2)*1;
                    let timezoneM = datetime.substr(20,2)*1;
                    let timezone = (timezoneH*60*60 + timezoneM*60) * 1000;

                    let time = d.getTime();
                    if(timezoneChar == '-'){
                        d.setTime(time + timezone);
                    }else{
                        d.setTime(time - timezone);
                    }
                }
            }else{
                return datetime;
            }
        }
        datetime = d.getFullYear() + "-" +
        this.prefixInteger((d.getMonth()+1),2) + "-" +
        this.prefixInteger(d.getDate(),2) + " " +
        this.prefixInteger(d.getHours(),2) + ":" +
        this.prefixInteger(d.getMinutes(),2) + ":" +
        this.prefixInteger(d.getSeconds(),2);
    }catch(e){

    }
    return datetime;
  }
  /**
   *
   *
   * @param {*} callback
   * @returns {{FileName:String,Title:String,Subject:String,Keywords,Author,Producer,Creator,CreationDate,ModDate}}
   */
  async getDocMetaDataByFormat(callback){
    if(!this.pdfui){
      return {};
    }
    let doc = await this.pdfui.getCurrentPDFDoc()
    if(!doc){
      return {};
    }
    let metadata = await doc.getMetadata().then((metaData) => {

      //this.popop.updateData(metaData);
      metaData.CreationDate = this.formatDatetime(metaData.CreationDate);
      metaData.ModDate = this.formatDatetime(metaData.ModDate);

      callback && callback(metaData);
      return metaData;
    });
    return metadata;
  }
  async saveToLocalByNameAndEnv(saveFileName, env) {
    let currentDoc;
    if (store.appStore.docModifiedCounts === 0 && !store.appStore.isCollaborationMode()) { // ESIGNCNRD-1072
      //  const originBuffer = await this.pdfui.pdfViewer.currentPDFDoc.getOriginalStream();
      //  const originBlob = new Blob([new Uint8Array(originBuffer)], { type : 'application/pdf'});
       // 分片方式打开的文档，要使用getDocBuffer获取文档buffer
       const originBuffer = await this.pdfui.pdfViewer.currentPDFDoc.getDocBuffer(this.pdfui.pdfViewer, true);
       const originBlob = new Blob(originBuffer, { type : 'application/pdf'});
       const fileName = this.pdfui.pdfViewer.currentPDFDoc.getFileName();
       currentDoc = [originBlob, fileName];
    } else {
      currentDoc = await this.getCurrentDocBuffer();
    }
    let fileName = saveFileName || currentDoc[1];
    let doc = await this.pdfui.getCurrentPDFDoc();
    if (doc.redacted) {
      fileName = this._formatFileName(fileName);
    }
    download(currentDoc[0], fileName, 'application/pdf', env);
  }
    async saveToLocal(callback, env, failCallback) {
        try {
            let currentDoc = await this.getCurrentDocBuffer();
            let fileName = currentDoc[1];
            let doc = await this.pdfui.getCurrentPDFDoc();
            if (doc.redacted) {
                fileName = this._formatFileName(fileName);
            }
            download(currentDoc[0], fileName, 'application/pdf', env);
            callback && callback();
        } catch(e) {
            failCallback && failCallback();
        }
    }
    _formatFileName(fileName) {
        const state = localStorage.getItem('PREFERENCES-DOCUMENTS');
        if (!state) {
            return fileName;
        }
        const preferencesDocuments = JSON.parse(state);
        const redaction = preferencesDocuments.redaction;
        const redactionPrefix = preferencesDocuments.redactionPrefix;
        const redactionSuffix = preferencesDocuments.redactionSuffix;
        if (!redaction) {
            return fileName;
        }
        const fileNameList = fileName.split('.');
        return redactionPrefix + fileNameList[0] + redactionSuffix + '.' + fileNameList[1];
    }
  // 0 - blob, 1 - base64
  async getCurrentDocStream(type, fileName) {
    const { docInfo: { fileName: fileNameFromStore } } = store.docStore
    const docFileName = fileName || fileNameFromStore || (await this.getFileName());
    const fileBuffer = (await this.getCurrentDocBuffer())[0];

    if (fileBuffer) {
      const fileBlob = new Blob(fileBuffer, { type: 'application/pdf' });

      fileBlob.name = docFileName || 'untitled.pdf'

      if (type === 0) {
        return fileBlob
      } else if (type === 1) {
        const fileBase64 = await blobToBase64(fileBlob);

        return fileBase64
      }
    }
  }
  async getCDocID() {
    // TODO FOXIT 不在使用cpdf文档，将文件fileController.getCDocID()修改为通过云文档的docId获取
    let cDocID
    // const doc = await this.pdfViewer.getCurrentPDFDoc()
    // let isCPDF = await this.isCPDF(doc)

    // if (!isCPDF) {
    //   throw new Error('this is not cpdf doc')
    // }

    // cDocID = await doc.getDocURI()

    return cDocID
  }
  async isCPDF(doc) {
    if(!doc) return null;
    const res = await doc.isCPDF()

    return res
  }
  async isCPDFForCurrentDoc() {
    const doc = await this.pdfViewer.getCurrentPDFDoc()
    const res = await this.isCPDF(doc)

    return res
  }
  async convertToCPDF(cPDFEndPoint) {
    const doc = await this.pdfViewer.getCurrentPDFDoc();
    const cPDFFileName = doc.getFileName()
    const { userToken: cPDFUserToken } = store.userNewStore
    const { userId: cPDFUserIDFromToken } = store.userNewStore.userData
    const { IAMToken } = store.loginNewStore
    // doc.convertToCPDF调用底层配置，
    await doc.convertToCPDF(cPDFFileName, cPDFEndPoint, cPDFUserToken, cPDFUserIDFromToken, IAMToken)
    .catch((error) => {
      throw error
    })
  }
  async removeCDocId(cPDFEndPoint) {
    const { token } = store.userStore

    if (!token) {
      return
    }

    const cPDFUserToken = token
    const doc = await this.pdfViewer.getCurrentPDFDoc();
    const cPDFFileName = doc.getFileName();

    const { cUserID: cPDFUserIDFromToken } = store.userStore.userInfo;

    await doc.removeCDocId(cPDFFileName, cPDFEndPoint, cPDFUserToken, cPDFUserIDFromToken).catch((error) => {
      throw error;
    });
  }
  async transformRectArray(rects, pageIndex){
    if (!rects || rects.length === 0) {
      return [];
    }

    let pagesRender = this.pdfViewer.getPDFDocRender().pagesRender;
    let pageRender = this.pageRender = this.pdfViewer.getPDFDocRender().getPDFPageRender(pageIndex) ;
    let userSetScale = this.pdfViewer.getPDFDocRender().scale;
    let scale = await pagesRender.getPageScale(pageIndex, userSetScale);
    pageRender.scale = scale;
    let page = await pageRender.getPDFPage();
    let rectArray = pageRender.transformRectArray(page, rects);
    return rectArray;
  }
  // Transform PDF page device rectangle to PDF page rectangle.
  async reverseDeviceRect(rect, pageIndex){
    if (!rect ) {
      return null;
    }

    let pagesRender = this.pdfViewer.getPDFDocRender().pagesRender;
    let pageRender = this.pageRender = this.pdfViewer.getPDFDocRender().getPDFPageRender(pageIndex) ;
    let userSetScale = this.pdfViewer.getPDFDocRender().scale;
    let scale = await pagesRender.getPageScale(pageIndex, userSetScale);
    pageRender.scale = scale;
    //let page = await pageRender.getPDFPage();
    let rc = pageRender.reverseDeviceRect(rect);
    return rc;
  }
  // Transform PDF page point device coordinate to PDF page coordinate.
  async reverseDevicePoint(pt, pageIndex){
    if (!pt ) {
      return null;
    }

    let pagesRender = this.pdfViewer.getPDFDocRender().pagesRender;
    let pageRender = this.pageRender = this.pdfViewer.getPDFDocRender().getPDFPageRender(pageIndex) ;
    let userSetScale = this.pdfViewer.getPDFDocRender().scale;
    let scale = await pagesRender.getPageScale(pageIndex, userSetScale);
    pageRender.scale = scale;
    //let page = await pageRender.getPDFPage();
    let _pt = pageRender.reverseDevicePoint(pt);
    return _pt;
  }
  doAnnotSelectionState(pdfui, Events){
    this.annotationStateHandler.bindAnnotSelectionState(pdfui, Events)
  }

  onClickAnnotTooltip({btnName}){
    this.annotationStateHandler.onClickAnnotSelectionTooltip({btnName})
  }
  async findTextInWholeDoc({doc, text, mode = 0}) {
    if(mode === void 0) mode = 0;
    const textSearch = await doc.getTextSearch(text, mode);//1区分大小写查找
    let match = await textSearch.findNext();
    const results = []
    while (match) {
        results.push(match)
        match = await textSearch.findNext();
    }
    return results;
  }

  async findTextByPage({doc, text, mode = 0, pageIndex, startCharIndex, endCharIndex}) {
    if(mode === void 0) mode = 0;
    const textSearch = await doc.getTextSearch(text.trim(), mode);//1区分大小写查找
    textSearch.setCurrentPageIndex(pageIndex);
    textSearch.setStartPageIndex(pageIndex);
    textSearch.setEndPageIndex(pageIndex);
    let match = await textSearch.findNext();
    const results = []
    while (match) {
      if(startCharIndex !== void 0 && endCharIndex !== void 0){
        if (match.match.pageIndex === pageIndex && match.match.startCharIndex >= startCharIndex && match.match.endCharIndex <= endCharIndex) {
          results.push(match)
        }
      }else{
        results.push(match)
      }
      match = await textSearch.findNext();
    }
    return results;
  }

  async findTextByPageRange({doc, text, mode = 0, startPage, endPage}) {
    //if(mode === void 0) mode = 0;
    const textSearch = await doc.getTextSearch(text.trim(), mode);//1区分大小写查找
    startPage !== void 0 && textSearch.setStartPageIndex(startPage);
    startPage !== void 0 && textSearch.setCurrentPageIndex(startPage);
    endPage !== void 0 && textSearch.setEndPageIndex(endPage);
    let match = await textSearch.findNext();
    const results = []
    while (match) {
      results.push(match);
      match = await textSearch.findNext();
    }
    return results;
  }

  async addAnnotBySearchMatch({doc, match, contents,subject, type='highlight', uniqueIDName=''}){
    let pageIndex = match.getPageIndex();
    let startCharIndex     = match.getStartCharIndex();
    let endCharIndex       = match.getEndCharIndex();
    let pdfPage = await doc.getPageByIndex(pageIndex);
    let formatMatch = this.formatTextMatch(match, 0);
    let annotJson = {
      flags: 4,
      rect: {left: 0, right: 0, top: 0, bottom: 0},
      type: type,
      contents,
      subject,
      coords: []
    }
    uniqueIDName && (annotJson['name'] = uniqueIDName)

    let Annot_Type = window.UIExtension.PDFViewCtrl.PDF.annots.constant.Annot_Type;

    const rectsLength = formatMatch.rects.length
    let result = null
    const rectsList = []

    for (let i = 0; i < rectsLength; i++) {
      annotJson.coords.push({
        ...formatMatch.rects[i], // top right bottom left
        rotation: pdfPage.getRotation(),
        start: startCharIndex,
        end: endCharIndex,
        text: formatMatch.mark,
      })
      rectsList.push(formatMatch.rects[i])
    }
    // console.error('addAnnotBySearchMatch', {...match}, {...annotJson}, [...rectsList])
    if (type === Annot_Type.redact) {
      result = pdfPage.markRedactAnnot(rectsList, annotJson)
    } else {
      result = pdfPage.addAnnot(annotJson)
    }
    return result;
  }

  async addAnnotAtPoint({doc, pageIndex, point, contents, type, uniqueIDName}){
    type = (type === 'note')? 'text':type;
    //let pageIndex = match.getPageIndex();
    //let startCharIndex     = match.getStartCharIndex();
    //let endCharIndex       = match.getEndCharIndex();
    let pdfPage = await doc.getPageByIndex(pageIndex);
    let info = pdfPage.info;
    //let formatMatch = this.formatTextMatch(match, 0);
    //let rc = await this.reverseDeviceRect({left: point.x, right: point.x+20, top: point.y, bottom: point.y+20}, pageIndex);
    let rc = {left: point.x, right: point.x+20, top: (info.height - point.y), bottom: (info.height - point.y -20)};
    let annotJson = {
      flags: 24,
      rect: rc,
      type: type,
      contents
    }
    uniqueIDName && (annotJson['name'] = uniqueIDName)
    return pdfPage.addAnnot(annotJson);
  }
  async removeAnnotsAtPoint({doc, pageIndex, point, type, uniqueIDPrefix}){
    type = (type === 'note')? 'text':type;
    let page = await doc.getPageByIndex(pageIndex);
    let info = page.info;
    //let pt = await this.reverseDevicePoint([point.x,point.y], pageIndex);
    let pt = [point.x,(info.height - point.y)] ;
    let annots = await page.getAnnots();
    let list = [];
    annots.forEach((annot)=>{
      let annotRect = annot.getRect();
      if(annot.getType() !== type){
        return;
      }
      if(!isInRect({pt1:{x:pt[0],y:pt[1]}, rc2:annotRect})){
        return;
      }
      let id = annot.getUniqueID();

      if(id && id.indexOf(uniqueIDPrefix) !== -1){
        list.push(id);
      }
    })

    let tasks = [];

    list.forEach((id)=>{
      let task = page.removeAnnotById(id);
      tasks.push(task);
    })
    let result = await Promise.all(tasks);
    return result;

  }

  async getAnnotsContentAtPoint({doc, pageIndex, point, type, uniqueIDPrefix}){
    type = (type === 'note')? 'text':type;
    //let pt = await this.reverseDevicePoint([point.x,point.y], pageIndex);
    let page = await doc.getPageByIndex(pageIndex);
    let info = page.info;
    //let pt = await this.reverseDevicePoint([point.x,point.y], pageIndex);
    let pt = [point.x,(info.height - point.y)] ;
    let annots = await page.getAnnots();
    let list = [];
    annots.forEach((annot)=>{
      let annotRect = annot.getRect();
      if(annot.getType() !== type){
        return;
      }
      if(!isInRect({pt1:{x:pt[0],y:pt[1]}, rc2:annotRect})){
        return;
      }
      let id = annot.getUniqueID();
      if(id && id.indexOf(uniqueIDPrefix) === -1){
        return;
      }
      let content = annot.getContent();
      list.push({id, content});

    })

    return list;

  }

  async getDevicePointAndMatrix({pageIndex, page, pt, matrix}){
    let docRender   = this.pdfViewer.getPDFDocRender();
    let pagesRender = docRender.pagesRender;
    //let pageRender = docRender.getPDFPageRender(pageIndex) ;
    let userSetScale = docRender.scale;
    let scale = await pagesRender.getPageScale(pageIndex, userSetScale);
    let [pxLeft, pxTop] = page.getDevicePoint(pt, scale);
    matrix.scale(scale, scale);

    return {devicePt: [pxLeft, pxTop], deviceMatrix: matrix} ;
  }
  async getAnnotsBySearchMatch({doc, match, type='highlight', uniqueIDPrefix='ai_plugin_'}){
    //isSameRect
    let pageIndex = match.getPageIndex();
    let rects = match.getRects();
    let rect = {...rects[0]}; // bottom left rigth top
    let page = await doc.getPageByIndex(pageIndex);

    let annots = await page.getAnnots();

    let list = [];
    annots.forEach((annot)=>{
      if (!annot.isMarkup()) {
        return;
      }
      const info = annot.getInfo();

      let annotRect = annot.getRect();

      if (info.quadPoints.length > 0) {
        if (!isSameRects({rcs:rects, qps:info.quadPoints})) {
          return;
        }
      } else {
        if(!isSameRect({rc1:annotRect, rc2:rect})){
          return;
        }
      }

      if(annot.getType() !== type){
        return;
      }
      let id = annot.getUniqueID();

      if(id && id.indexOf(uniqueIDPrefix) !== -1){
        list.push(id);
      }
    })
    return list;
    // let matrix = page.getDeviceMatrix();
    // let pt = [(rect.left+rect.right)/2, (rect.top+rect.bottom)/2];
    // let {devicePt, deviceMatrix} = await this.getDevicePointAndMatrix({pageIndex, page, pt, matrix});
    // let tolerance = 0;
    // let annotId = await page.getAnnotIdAtDevicePoint(devicePt, tolerance ,[deviceMatrix.a, deviceMatrix.b, deviceMatrix.c, deviceMatrix.d, deviceMatrix.e, deviceMatrix.f]);
    // if(!annotId || annotId === -1)
    //   return ''
    // let annots = await page.getAnnotsByIdArray([annotId]);
    // let annot = annots[0];
    // if(annot.getType() === type)
    //   return annotId
    // return ''
  }
  async removeAnnotsBySearchMatch({doc, match, /* type='highlight', */ ids=[]}){
    let pageIndex = match.getPageIndex();
    let page = await doc.getPageByIndex(pageIndex);
    let tasks = [];

    ids.forEach((id)=>{
      let task = page.removeAnnotById(id);
      tasks.push(task);
    })
    let list = await Promise.all(tasks);
    return list;
  }
  async redactApplyBySearchMatch({doc, match, type='highlight', uniqueIDName}){
    //isSameRect
    let pageIndex = match.getPageIndex();
    let rects = match.getRects();
    let rect = rects[0];
    let page = await doc.getPageByIndex(pageIndex);
    let result = true;

    let annots = await page.getAnnots();
    annots.forEach((annot)=>{
      if (!annot.isMarkup()) {
        return;
      }
      const info = annot.getInfo();

      let annotRect = annot.getRect();

      if (info.quadPoints.length > 0) {
        if (!isSameRects({rcs:rects, qps:info.quadPoints})) {
          return;
        }
      } else {
        if(!isSameRect({rc1:annotRect, rc2:rect})){
          return;
        }
      }
      if(annot.getType() !== type){
        return;
      }
      let id = annot.getUniqueID();

      if(id === uniqueIDName && !annot.info.isDeleted){
        try {
          annot.apply()
        } catch (error) {
          result = false
        }
      }
    })
    return result;
  }

  formatTextMatch(match, index){
    let sentence           = match.getSentence();
    let pageIndex          = match.getPageIndex();
    let sentenceStartIndex = match.getSentenceStartIndex();
    let startCharIndex     = match.getStartCharIndex();
    let endCharIndex       = match.getEndCharIndex();
    let count              = endCharIndex - startCharIndex + 1;
    let before             = sentence.slice(0, sentenceStartIndex);
    let mark               = sentence.slice(sentenceStartIndex, sentenceStartIndex + count);
    let after              = sentence.slice(sentenceStartIndex + count);
    return {
      pageIndex,
      before,
      mark,
      after,
      startIndex: index,
      rects:match.getRects()
    }
  }

  formatFindNexts (dataList) {
    //let dataList = data.list;
    if(!dataList) return null;
    let list = [];

    for (let i = dataList.length; i--;) {
        let  match = dataList[i];
        let  item  = this.formatTextMatch(match, i);
        list[i]    = item;
    }
    return {
        hasMore: false,
        list: list,
    }
  }

  removeSelectMark($parent) {
    $parent.find(markSelectSelector).remove();
  }

  appendSelectMark($parent, rectArray, isColorBurn) {
    this.removeSelectMark($parent);
    //@ts-ignore
    let cls = markSelectClassName;
    isColorBurn && (cls += ' ' + markColorBurnCls)
    let $frag = $$(document.createDocumentFragment());
    for (let i = 0, j = rectArray.length; i < j; i++) {
        let rect = rectArray[i];
        let style = ['top:' + rect.top + 'px', 'left:' + rect.left + 'px', 'width:' + (rect.right - rect.left) + 'px', 'height:' + (rect.bottom - rect.top) + 'px'].join(';')
        $frag.append('<mark class="' + cls + '" style="' + style + '"></mark>')
    }
    $parent.append($frag);

    this.$lastParent = $parent
  }

  updateSelectMark(data){
    if (!data) {
        return;
    }

    let pagesRender = this.pdfViewer.getPDFDocRender().pagesRender;
    let pageRender = this.pageRender = this.pdfViewer.getPDFDocRender().getPDFPageRender(data.pageIndex) ;
    let userSetScale = this.pdfViewer.getPDFDocRender().scale;
    pagesRender.getPageScale(data.pageIndex, userSetScale).then((scale) => {
        pageRender.scale = scale;
        pageRender.getPDFPage().then((page) => {
            let rectArray = pageRender.transformRectArray(page, data.rects);

            this.appendSelectMark(this.pageRender.$handler, rectArray);
            //this.showSelectMark(rectArray);
        });
    })
  }

  clearMarkTexts(){

    !!this.$lastParent && (this.removeSelectMark(this.$lastParent))
    this.$lastParent = null;
  }

  /** *******************AI Plugin label action begin ********************/
  onListenSwitchToFn(/* CurrentStateHandler, LastStateHandler */){
    this.isInSelectTextStateHandler = false;

    this._cleanListenerOfSwitchTo();

    this.cancelSwitchToCallback && this.cancelSwitchToCallback();
    this.cancelSwitchToCallback = null;
    this.prevStateHandler = null;
  }
  onListenSelectText({page,text,rectArray}){
    if(!this.isInSelectTextStateHandler)return;
    this.selectTextData = {pdfPage: page, text, rectArray};

    let nowPage = (page && page.info && page.info.index) || 0
    this._onListenTap(nowPage)
  }
  _onListenTap(nowPage) {
    let viewer = this.pdfViewer;
    let pageRender  = viewer.getPDFPageRender(nowPage);
    console.log('===labelToolnowPage==', pageRender, nowPage)
    let $handler = pageRender.$handler;
    $handler.addClass('fv__select-text-image-state-handler');
    let eHandler = $handler[0];
    let hammer = new Hammer.Manager(eHandler, {
        recognizers: [
            [Hammer.Pan, { direction: Hammer.DIRECTION_ALL }]
        ]
    });
    hammer.add(new Hammer.Tap({ event: 'doubletap', taps: 2 }));
    hammer.add(new Hammer.Tap({ event: 'singletap' }));
    hammer.get('doubletap').recognizeWith('singletap');
    hammer.get('singletap').requireFailure('doubletap');
    hammer.on('singletap', (/*e*/) => {
      this.selectTextData = null
    });
    hammer.on('doubletap', (/*e*/) => {
      this.selectTextData = null
    });
	}

  _cleanListenerOfSwitchTo(){
    let Events = UIExtension.PDFViewCtrl.Events;
    window.pdfui.removeViewerEventListener(Events.switchStateHandler, this.onListenSwitchToFn);
    window.pdfui.removeViewerEventListener(Events.selectText, this.onListenSelectText);
  }
  async _switchToLastHandler(){
    if(!this.prevStateHandler){
      console.warn('this.prevStateHandler is null')
      return;
    }
    let stateHandlerManager = await window.pdfui.getStateHandlerManager();
    stateHandlerManager;;
    if(stateHandlerManager){
      stateHandlerManager.switchTo(this.prevStateHandler.getStateName());
    }
    this.prevStateHandler = null;
  }

  async switchToSelectText({/* onEndSelectTextCallback, */ cancelSwitchToCallback=null}={}){
    if (!this.pdfui) {
      return false;
    }

    let doc = await this.pdfui.getCurrentPDFDoc();
    if (!doc) {
      return false;
    }
    //let docRender = await this.pdfui.getPDFDocRender();
    //let currentPageIndex = docRender.getCurrentPageIndex();
    //let pageRender = this.pdfViewer.getPDFPageRender(currentPageIndex);
    let stateHandlerManager = await window.pdfui.getStateHandlerManager();
    if(!stateHandlerManager){
      return false;
    }
    let prevStateHandler = stateHandlerManager.getCurrentStates();
    if(!prevStateHandler){
      console.warn('prevStateHandler is null');
    }
    this.prevStateHandler = prevStateHandler;
    stateHandlerManager.switchTo(UIExtension.PDFViewCtrl.STATE_HANDLER_NAMES.STATE_HANDLER_SELECT_TEXT_IMAGE);

    let Events = UIExtension.PDFViewCtrl.Events;
    this.pdfui.addViewerEventListener(Events.switchStateHandler, this.onListenSwitchToFn);
    this.pdfui.addViewerEventListener(Events.selectText, this.onListenSelectText);

    this.selectTextData = null;
    this.cancelSwitchToCallback = cancelSwitchToCallback;
    this.isInSelectTextStateHandler = true;
    return true;
  }
  cancelSwitchToSelectText(){
    if(!this.isInSelectTextStateHandler) {
      return;
    }
    this.isInSelectTextStateHandler = false;
    this.cancelSwitchToCallback = null;
    this.selectTextData = null;

    this._cleanListenerOfSwitchTo();
    this._switchToLastHandler();
  }
  async getSelectedText(){
    //this.selectTextData = {pdfPage,text,rectArray};
    if(!this.selectTextData){
      return null;
    }
    let doc = await this.pdfui.getCurrentPDFDoc();
    if (!doc) {
      return null;
    }
    const {pdfPage,text,rectArray} = this.selectTextData;
    let pageIndex = pdfPage.getIndex();
    let result = await this.findTextByPageRange({doc, text, mode:1, startPage: pageIndex, endPage:pageIndex});
    if(result.length === 0){
      return null;
    }

    let index = result.findIndex((match)=>{
      let rc1 = rectArray[0];
      let rects = match.getRects();
      let rc2 = rects[0];
      if(isSameRect({rc1, rc2}) && rectArray.length === rects.length){
        return true;
      }
      return false;
    })
    //findTextByPageRange
    if(index === -1){
      return null;
    }
    return {pageIndex, text, index};
  }
  // *******************AI Plugin label action end ********************

  markTextSelection(match){
    this.clearMarkTexts()
    let formatResult = this.formatTextMatch(match);
    this.updateSelectMark(formatResult)
    // let Events     = UIExtension.PDFViewCtrl.Events;
    // let _this = this;
    // function switchTo() {
    //   window.pdfui.getStateHandlerManager().then(stateHandlerManager => {
    //       const prevStateHandler = stateHandlerManager.getCurrentStates();
    //       stateHandlerManager.switchTo(UIExtension.PDFViewCtrl.STATE_HANDLER_NAMES.STATE_HANDLER_CHECK_THE_SEARCH /* 'checkTheSearch' */ /* CheckTheSearchStateHandler.getStateName() */);
    //       console.warn('set event')
    //       _this.pdfViewer.eventEmitter.emit(Events.checkTheSearch, formatResult, prevStateHandler);
    //   });
    // }

    this.gotoPage(formatResult, ({/* pdfPage, */ pageRender})=>{
      // switchTo()
      this.$lastParent = pageRender.$handler
    })
  }

  gotoPage(formatMatch, callback){
    let viewer = this.pdfViewer;
    let rects  = formatMatch.rects;
    let top    = rects[0].top,
        left   = rects[0].left,
        right  = rects[0].right,
        bottom = rects[0].bottom;
    rects.map((rect) => {
      top    = Math.max(rect.top, top);
      bottom = Math.min(rect.bottom, bottom);
      left   = Math.min(rect.left, left);
      right  = Math.max(rect.right, right);
    });
    let pageIndex   = formatMatch.pageIndex;
    let scrollWrap  = viewer.pdfViewerRender.scrollWrap;
    let viewTop     = scrollWrap.getScrollTop(),
        viewBottom  = viewTop + scrollWrap.getHeight(),
        viewLeft    = scrollWrap.getScrollLeft(),
        viewRight   = viewLeft + scrollWrap.getWidth();
    let pageRender  = viewer.getPDFPageRender(pageIndex);
    let docRender   = viewer.getPDFDocRender();
    let pagesRender = docRender.pagesRender;
    pagesRender.getPageScale(pageIndex, docRender.scale).then((scale) => {
      // use scale after render
      pageRender.scale = scale;
      pageRender.getPDFPage().then((pdfPage) => {
        let [pxLeft, pxTop] = pdfPage.getDevicePoint([left, top], pageRender.getScale());
        let offsetTop       = pageRender.$ui[0].offsetTop + pxTop,
            offsetLeft      = pageRender.$ui[0].offsetLeft + pxLeft;
        if (offsetTop < viewTop || offsetTop > viewBottom || offsetLeft < viewLeft || offsetLeft > viewRight) {
          docRender.goToPage(pageIndex, { x: pxLeft, y: pxTop }).then(() => {
            callback && callback({ pdfPage, pageRender });
          });
        } else {
          callback && callback({ pdfPage, pageRender });
        }
      });
    });
  }
   // TODO FOXIT 通过页码跳转到指定页
   gotoPageByIndex(pageIndex, callback) {
    let viewer = this.pdfViewer;
    let docRender   = viewer.getPDFDocRender();
    docRender.goToPage(pageIndex).then(() => {
      callback && callback();
    });
  }

  async addAnnotBySearch({doc, text, pageIndex}){
    let list = await this.findTextByPage({doc, text, pageIndex});
    if(list.length === 0){
      return 0;
    }
    let match = list[0];
    return this.addAnnotBySearchMatch({doc, match, contents:'contents', subject:'subject'})
  }

  async setFormFieldValue({doc, fieldName, value}){
    let form = await doc.loadPDFForm()
    //let form = doc.getPDFForm();
    let pdfFileds = form.getField(fieldName);
    if(!pdfFileds){
      return false;
    }
    // fixed error with sdk
    if(!(pdfFileds instanceof Array)){
      pdfFileds = [pdfFileds];
    }
    pdfFileds.forEach((field)=>{
      field.setValue(value);
      form.calculate(field);
    })
  }

  async addText({doc, page, pageIndex, text, fontSize=12, position}){

    let pdfPage = page || await doc.getPageByIndex(pageIndex);
    //let page = await doc.getPageByIndex(pageIndex);
    return pdfPage.addGraphicsObject({
      fontSize: fontSize,
      weight: 400,
      italic: false,
      fillColor: 0xff000000,
      text: text,//'123111111联通，我们需要什么',
      font: {standardId:0},
      originPosition:position,//{x:5, y:600},
      type: 1
    })
  }

  async replaceText({doc, match, text}){
    let pageIndex = match.getPageIndex();
    let page = await doc.getPageByIndex(pageIndex);
    let pageRender = this.pdfViewer.getPDFDocRender().getPDFPageRender(pageIndex) ;
    let torenlance = Math.min(2/pageRender.scale,2);
    let type = 1;
    let rects = match.getRects();
    let rc = rects[0];
    //let tasks = [];
    let i = 0;
    do {
      let rect = rects[i];
      page.graphicObjects && page.graphicObjects.forEach(object=>object.destroy());
      page.graphicObjects=[];
      do {
        let graphicObjects =  await page.getGraphicsObjectsInRect(rect, torenlance, type);
        if(!graphicObjects || graphicObjects.length < 1) {
          break;
        }
        await page.removeGraphicsObject(graphicObjects[0]);
      } while (true);

      i++;
    } while (i< rects.length);
    let position ={x: rc.left, y:rc.bottom}
    let result = await this.addText({doc, page, pageIndex, text, position});
    return result;
  }
  async hasForm(){
    let doc =  await window.pdfui.getCurrentPDFDoc();
    let hasForm = await doc.hasForm();
    return hasForm;
  }
  async isShowFormMessage(){
    const hasForm = await this.hasForm();
    if(hasForm){
       store.docStore.setFormMessage({ title: "Notification.FormFieldsFound", info: "Notification.ContainForm"});
    } else {
      store.docStore.setFormMessage(null);
    }
  }
  async isShowFormResetButton(){
    const hasForm = await this.hasForm();
    let formReset =  await window.pdfui.getComponentByName(FORM_RESET_FIELD);
    if (formReset) {
      if(!hasForm){
        // formReset.disable()
        formReset.lock()
      }else{
        // formReset.enable();
        formReset.unlock();
      }
    }
  }
  async autoRecognitionForm(){
    let  pdfDoc = await window.pdfui.getCurrentPDFDoc();

    await pdfDoc.autoRecognitionForm();
  }

  // iDox-ai start

  async getRedactAnnots ({match, type, annots}) {
    let rects = match.getRects();
    let rect = rects[0];

    annots.forEach((annot)=>{
      let annotRect = annot.getRect();
      if(!isSameRect({rc1:annotRect, rc2:rect})){
        return;
      }
      if(annot.getType() !== type){
        return;
      }

      this.addedAnnotsList.push(annot)
    })
  }

  async addedAnnotsApply ({uniqueIDNames}) {
    let applyFailedList = [];

    for (let i = 0; i < uniqueIDNames.length; i++) {
      let annotsLength = this.addedAnnotsList.length - 1
      for (let j = annotsLength; j > -1; j--) {
        if(uniqueIDNames[i] !== this.addedAnnotsList[j].getUniqueID()) continue;
        if (!this.addedAnnotsList[j].info || this.addedAnnotsList[j].info.isDeleted) {
        applyFailedList.push(this.addedAnnotsList[j].id)
          continue;
        }
        try {
          await this.addedAnnotsList[j].apply()
        } catch (error) {
          applyFailedList.push(this.addedAnnotsList[j].id)
          this.addedAnnotsList.splice(j, 1)
          continue;
        }
        this.addedAnnotsList.splice(j, 1)
      }
    }

    return applyFailedList;
  }

  async cleanAddedAnnotsList ({type="IDlist", uniqueIDNames}) {
    if (type === 'all') {
      this.addedAnnotsList = []
    } else if (type === 'IDlist') {
      let annotsLength = this.addedAnnotsList.length - 1

      for (let i = annotsLength; i > -1; i--) {
        if (this.addedAnnotsList[i].getUniqueID() && uniqueIDNames.indexOf(this.addedAnnotsList[i].getUniqueID()) != -1) {
          this.addedAnnotsList.splice(i, 1)
        }
      }
    }
  }

  async getFileTexts ({doc, pageIndex}) {
    const getTextsByPageIndex = async (pageIndex) => {
      let nowPageText = '';
      let page = await doc.getPageByIndex(pageIndex)
      let count = await page.getTextRectCount();
      for (let i = 0; i< count; i++) {
        let textInfo = await page.getTextByRectIndex(i);
        nowPageText += textInfo.text + ' '
      }
      return nowPageText
    }

    const result = []

    if (pageIndex === -1) {
      const pageCount = doc.getPageCount();

      for (let i = 0; i < pageCount; i++) {
        const nowPageText = await getTextsByPageIndex(i)
        result.push(nowPageText)
      }
    } else {
      result.push(await getTextsByPageIndex(pageIndex))
    }
    return result
  }

  async checkFilePermission({doc}) {
    const pdfRender = await pdfui.getPDFDocRender();
    const userPermission = pdfRender.getUserPermission();

    const checkExtract = userPermission.checkExtract();

    const checkAnnotForm = userPermission.checkAnnotForm();

    const checkPwd = checkExtract && checkAnnotForm;

    const securityEncryptType = window.UIExtension.PDFViewCtrl.shared.securityEncryptType;
    const isWrapped = await doc.hasDocIsWrapped();
    const securityType = await doc.getSecurityType();

    let result = 0;

    if (isWrapped && securityType != securityEncryptType.Password) {
			result = 400026;
    } else if (securityType === securityEncryptType.Password && !checkPwd) {
			result = 400027;
    }

    return result;
  }
  async clearAllUndoRedoStorage() {
    const doc = await this.pdfViewer.getCurrentPDFDoc();

    doc.engine.eventEmitter.emit(UIExtension.UIEvents.undoRedoStoreChange, null, 'clearAll')
  }
}